/**
 * @generated SignedSource<<04f50aec97d5f6ba4c8a04c1acb62ffc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Aim = "ANALGESIA_ANTI_INFLAMMATORY_TREATMENT" | "DECONGESTION" | "FUNCTIONAL_BANDAGE_TAPE" | "IMPROVEMENT_OF_CARDIO_PULMO_FUNCTION" | "IMPROVEMENT_OF_JOINT_FUNCTION" | "IMPROVEMENT_OF_MOBILITY" | "IMPROVEMENT_OF_MUSCLE_FUNCTION" | "INSTRUCTION" | "PROPRIOCEPTION_COORDINATION";
export type ConditionStage = "ACUTE" | "CHRONIC" | "SUBACUTE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Occurrence = "FIRST_OCCURRENCE" | "RECURRENCE";
export type PrescriptionRepetition = "FIRST" | "FOURTH" | "SECOND" | "THIRD";
export type ReasonForPhysiotherapy = "ACCIDENT" | "IVMV" | "SICKNESS";
export type Side = "LEFT" | "RIGHT";
export type TreatmentUnitPerDay = "ONCE" | "TWICE";
import { FragmentRefs } from "relay-runtime";
export type chPhysiotherapyFragment$data = {
  readonly aims: ReadonlyArray<Aim>;
  readonly allergies: ReadonlyArray<string> | null;
  readonly concludedAt: string | null;
  readonly concludedBy: string | null;
  readonly conditionStage: ConditionStage;
  readonly conditions: ReadonlyArray<string> | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly diagnosisCode: string;
  readonly duration: string | null;
  readonly fileId: string | null;
  readonly fileMetadata: {
    readonly documentType: string;
    readonly extension: string;
    readonly lengthInKilobytes: number;
  } | null;
  readonly healthcareProviderId: string | null;
  readonly id: string;
  readonly internalNote: string | null;
  readonly isHomeTreatment: boolean;
  readonly language: Language;
  readonly leadingSymptom: string | null;
  readonly medicationIds: ReadonlyArray<string> | null;
  readonly occurrence: Occurrence;
  readonly patientId: string;
  readonly prescriptionRepetition: PrescriptionRepetition;
  readonly progressNoteId: string;
  readonly reason: ReasonForPhysiotherapy;
  readonly sentAt: string | null;
  readonly sentBy: string | null;
  readonly sides: ReadonlyArray<Side> | null;
  readonly signedAt: string | null;
  readonly signedBy: string | null;
  readonly treatmentUnit: number;
  readonly treatmentUnitPerDay: TreatmentUnitPerDay;
  readonly trigger: string | null;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly " $fragmentType": "chPhysiotherapyFragment";
};
export type chPhysiotherapyFragment$key = {
  readonly " $data"?: chPhysiotherapyFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"chPhysiotherapyFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chPhysiotherapyFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aims",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allergies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conditions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medicationIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conditionStage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "healthcareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leadingSymptom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prescriptionRepetition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sides",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trigger",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentUnitPerDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHomeTreatment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occurrence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ch_PhysiotherapyPrescription",
  "abstractKey": null
};

(node as any).hash = "89b5f741c1c6f167ddea73650068f171";

export default node;
